<template>
    <wrapper>
        <div class="blog">
            <div class="title-underlined">{{ $t('blog') }}</div>
            <div :class="[blogPosts.length > 3 ? 'justify-content-between' : 'justify-content-start', 'row']">
                <div v-for="post in blogPosts" :key="post.id" class="col-12 col-md-6 col-lg-3 mb-5">
                    <div class="blog-image" :style="{ backgroundImage: 'url(' + (post.image_url || img_placeholder) + ')' }"></div>

                    <h6 class="my-4" v-text="post.created_on"></h6>

                    <h5 class="my-3">
                        <router-link class="text-dark" :to="{ name: 'blog-detail', params: { blogId: post.id } }">
                            {{ post.title }}
                        </router-link>
                    </h5>
                </div>
            </div>
            <div class="blog-btn text-center mt-5">
                <b-button variant="primary" class="btn-trimm-wide" pill @click="goTo('/blogs')">{{ $t('seeMore') }}</b-button>
            </div>
        </div>
    </wrapper>
</template>

<script>
    import Wrapper from "@/components/common/wrapper.vue";
    import { blogService } from "@/services";

    export default {
        name: "blog",

        components: {
            wrapper: Wrapper
        },

        data() {
            return {
                blogPosts: [],
                img_placeholder: "/src/assets/main/blog/working-out.png"
            };
        },

        async created() {
            let data = {
                month: "",
                tag: "",
                pageNumber: 1,
                pageSize: 4,
                totalItems: 4,
                totalPages: 1,
                firstItem: 0,
                lastItem: 3,
                has_previous_page: true,
                has_next_page: true,
                custom_properties: {}
            };

            let response = await blogService.getBlogList(data);

            //We take only four blogs for the home page
            this.blogPosts = response.blog_posts.slice(0, 4);
        },

        methods: {
            goTo(url) {
                this.$router.push(url);
            }
        }
    }
</script>